import Config from '@/config';
import { EngineService } from '@/services/engine';
import { fetchExternalBlob } from '@/utils/http';

export function fetchImageBlob(url: string): Promise<Blob> {
    return isEngineUrl(url)
        ? EngineService.fetchImageBlob(url)
        : fetchExternalBlob(url);
}

function isEngineUrl(url: string): boolean {
    return url.startsWith(Config.VITE_ENGINE_URL);
}
